/* eslint-disable camelcase */
import axios from 'axios';

import { MASTER_FEATURE_ENDPOINT, MASTER_TAG_ENDPOINT } from '@dynameat/constants';

export const getMasterFeatureListRequest = () => axios.get(MASTER_FEATURE_ENDPOINT());
export const getMasterTagsListRequest = () => axios.get(MASTER_TAG_ENDPOINT());
